import { render, staticRenderFns } from "./PartsOrderSummaryComponent.vue?vue&type=template&id=151dc8a8&"
import script from "./PartsOrderSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./PartsOrderSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports